import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './accounting.actions';

@Injectable({
	providedIn: 'root',
})
export class MatterAccountingDispatch {
	@Dispatch()
	ExportCosmolex = (): actions.ExportCosmolex => new actions.ExportCosmolex();

	@Dispatch()
	ExportSoluno = (): actions.ExportSoluno => new actions.ExportSoluno();

	@Dispatch()
	ExportGhostPractice = (): actions.ExportGhostPractice =>
		new actions.ExportGhostPractice();

	@Dispatch()
	PrintCosmolex = (): actions.PrintCosmolex => new actions.PrintCosmolex();

	@Dispatch()
	PrintSoluno = (): actions.PrintSoluno => new actions.PrintSoluno();

	@Dispatch()
	PrintGhostPractice = (): actions.PrintGhostPractice =>
		new actions.PrintGhostPractice();

	@Dispatch()
	ExportLeap = (): actions.ExportLeap => new actions.ExportLeap();
}
